import { useEffect, useState } from "react";
import { getDiscountCodesEnabled } from "../api/discountCodesAPI";

/**
 * Whether this club accepts discount codes (the master switch), for any form
 * with a "Have a discount code?" box.
 *
 *   undefined  still asking: show no box yet, so it does not flash
 *   true       show the box
 *   false      hide the box (what the master switch says it does)
 *   null       the question could not be answered: show the box rather than
 *              hide it because of a failed request
 *
 * Until 2026-10-10 every form showed the box with the switch off, and every
 * code entered was turned down.
 */
export function useDiscountCodesEnabled(): boolean | null | undefined {
  const [answer, setAnswer] = useState<boolean | null | undefined>(undefined);
  useEffect(() => {
    let cancelled = false;
    // Any failure in asking reads as "could not be answered" (null): the box
    // is shown, never hidden by an error.
    Promise.resolve()
      .then(() => getDiscountCodesEnabled())
      .catch(() => null)
      .then((value) => {
        if (!cancelled) setAnswer(value ?? null);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return answer;
}

/** Hide the code box? Never when a code is already applied. */
export function hideDiscountBox(answer: boolean | null | undefined, hasAppliedCode: boolean): boolean {
  if (hasAppliedCode) return false;
  return answer === false || answer === undefined;
}
